if (!customElements.get('card-slider')) {
  
  customElements.define(
    
    'card-slider',
    
    class CardSlider extends HTMLElement {
      
      constructor() {
        super();
        this.swiperWrapper = this.querySelector('.swiper-wrapper');
        this.initSwiper();
      }
      
      get getSlideItems() {
        return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.swiperWrapper.children));
      }
      
      initSwiper() {
        
        const slider = this.querySelector('.swiper');
        
        console.log(slider);
        
        if (!slider) return;
        
        const swiper = new HYEtheme.Swiper.Swiper(slider, {
          modules: [
            HYEtheme.Swiper.Navigation,
            HYEtheme.Swiper.Scrollbar,
            HYEtheme.Swiper.Mousewheel
          ],
          navigation: HYEtheme.Swiper.NavigationDefault,
          scrollbar: HYEtheme.Swiper.ScrollbarDefault,
          mousewheel: HYEtheme.Swiper.MousewheelDefault,
          slidesPerView: 'auto',
          slidesPerGroupAuto: true,
          speed: 500,
          spaceBetween: 20,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          breakpoints: {
            750: {
              slidesOffsetBefore: 48,
              slidesOffsetAfter: 48
            },
            1280: {
              slidesOffsetBefore: 72,
              slidesOffsetAfter: 72
            }
          }
        });
        
        // handle theme editor
        
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            swiper.slideTo(this.getSlideItems.indexOf(event.target));
          });
        }
      }
    }
  );
}